import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { TokenService } from '../../core/service/token.service';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard implements CanActivate {

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
  //   return true;
  // }
    constructor(
      private cookieService: CookieService,
      private tokenService: TokenService,private router: Router ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    forkJoin([this.setListCookies()]).toPromise().then((res:any)=>{
      // console.log(res)
      if (res[0]?.length>0) {
        this.validateListCookies(res[0])
      }
    })

    if (this.tokenService.getDataToken()) {
      return true;
    }
    this.cookieService.delete('accessToken');
    this.cookieService.delete('refreshToken');

    this.router.navigate(['/callback-signin']);
    return false;
  }

  setListCookies() {
    var listCookies:any=[]
    return new Promise((resolve, reject) => {
      var theCookies = document.cookie.split(';').reduce((cookies, cookie:any) => {
        const [ name, value ] = cookie.split('=').map((c:any) => c.trim());
        // return { ...cookies, [name]: value };
        var ls:any=listCookies.push({key: name})
        return ls
      }, {});
      if (theCookies) {
        resolve(listCookies)
      }
    })
  }
  async validateListCookies(data:any){
    var domain=window.location.hostname
    var check = ['accessToken','accessTokenBackup', 'channelLogin', 'refreshToken', 'refreshTokenBackup', 'maxTimeToken']
    data.forEach(async(res:any)=>{
        if (!check.includes(res.key)) {
          // this.cookieService.delete(res.key, '/',domain, false, 'Lax')
          this.cookieService.delete(res.key, '/')
        }
    })
  }
}
